import { render } from "./ProjectenGanttChart.vue?vue&type=template&id=446262db&scoped=true"
import script from "./ProjectenGanttChart.vue?vue&type=script&lang=js"
export * from "./ProjectenGanttChart.vue?vue&type=script&lang=js"

import "./ProjectenGanttChart.vue?vue&type=style&index=0&id=446262db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446262db"]])

export default __exports__